package com.example.readingnotes.presentation.sales

import com.example.readingnotes.presentation.sales.SalesPeriod

/**
 * UI events for Sales Dashboard screen
 */
sealed interface SalesDashboardEvent {
    /**
     * Screen appeared - load initial data
     */
    data object OnAppear : SalesDashboardEvent

    /**
     * User changed period filter
     */
    data class OnPeriodChange(
        val period: SalesPeriod,
    ) : SalesDashboardEvent

    /**
     * User clicked refresh button
     */
    data object OnRefresh : SalesDashboardEvent

    /**
     * Clear error message
     */
    data object OnClearError : SalesDashboardEvent
}
